import variantsStockService from './variantsStockService'

export default variantsStockService



// WEBPACK FOOTER //
// ../src/services/variantsStockService/index.js